import { render } from "./OpeningHoursView.html?vue&type=template&id=983a4102&scoped=true&external"
import script from "./OpeningHoursView.js?vue&type=script&lang=js&external"
export * from "./OpeningHoursView.js?vue&type=script&lang=js&external"

import "./OpeningHoursView.css?vue&type=style&index=0&id=983a4102&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983a4102"]])

export default __exports__